import apiClient from "modules/main/services/apiClient";
import { selectCheckoutScenarioEndpoint } from "modules/main/services/endpoints";
import { SelectScenarioResponse } from "../types/scenarioSelection";

/**
 * Marks a checkout scenario as selected using the scenario id as backend order id.
 * @param scenarioId - Current cart creation scenario identifier.
 * @returns Backend confirmation for the selected scenario/order.
 */
export const selectScenario = async (scenarioId: number): Promise<SelectScenarioResponse> => {
    return await apiClient.put<SelectScenarioResponse>(selectCheckoutScenarioEndpoint(scenarioId));
};
